import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DoctorBreadcrumbService } from 'src/app/components/medical-profession/shared/breadcrumb.service';
import { CONSULTATION_TYPES } from 'src/app/constant/constant';
import { AppointmentZoom } from 'src/app/models/appointment';
import { ConsultationData } from 'src/app/models/consultdoctors';
import { PatientAccount } from 'src/app/models/PatientAccount';
import { ApiResult } from 'src/app/models/PromiseResult';
import { AppointmentService } from 'src/app/services/appointment.service';
import { PatientviewService } from 'src/app/services/patientview/patientview.service';
import { DateUtilService, moment_duration } from '../../../../utilities/date.util.service';
import { DietConsultationDataComponent } from '../diet-consultation-data/diet-consultation-data.component';
import { DoctorFeedbackComponent } from '../doctor-feedback/doctor-feedback.component';
import { EglobaldoctorsConultationsComponent } from '../eglobaldoctors-conultations/eglobaldoctors-conultations.component';
import { MedicalReportsComponent } from '../medical-reports/medical-reports.component';
import { PastMedicalHistoryComponent } from '../past-medical-history/past-medical-history.component';
import { PatientBasicDetailsComponent } from '../patient-basic-details/patient-basic-details.component';
import { PatientvMessageCentreComponent } from '../patientv-message-centre/patientv-message-centre.component';
import { ProviderStateService } from 'src/app/services/provider-state.service';
class Tabs_Index {
    DEMOGRAPHIC_INFORMATION: number = 0;
    PATIENT_HISTORY: number = 1;
    UPLOAD_MEDICAL_REPORTS: number = 2;
    EGLOBALDOCTORS_CONSULTATIONS: number = 3;
    MESSAGE_CENTER: number = 4;
    DOCTORS_FEEDBACK: number = 5;
    DIET_CONSULTATION_DATA: number = 6;
}

class TabsClicked {
    PARENT_PATIENT_VIEW: boolean = false;
    DEMOGRAPHIC_INFORMATION: boolean = false;
    PATIENT_HISTORY: boolean = false;
    UPLOAD_MEDICAL_REPORTS: boolean = false;
    EGLOBALDOCTORS_CONSULTATIONS: boolean = false;
    MESSAGE_CENTER: boolean = false;
    DOCTORS_FEEDBACK: boolean = false;
    DIET_CONSULTATION_DATA: boolean = false;
    constructor(default_value: boolean) {
        this.PARENT_PATIENT_VIEW = default_value;
        this.DEMOGRAPHIC_INFORMATION = default_value;
        this.PATIENT_HISTORY = default_value;
        this.UPLOAD_MEDICAL_REPORTS = default_value;
        this.EGLOBALDOCTORS_CONSULTATIONS = default_value;
        this.MESSAGE_CENTER = default_value;
        this.DOCTORS_FEEDBACK = default_value;
        this.DIET_CONSULTATION_DATA = default_value;
    }
}

class Tabs {
    index: Tabs_Index = new Tabs_Index();
    list = [
        "DEMOGRAPHIC_INFORMATION",
        "PATIENT_HISTORY",
        "UPLOAD_MEDICAL_REPORTS",
        "EGLOBALDOCTORS_CONSULTATIONS",
        "MESSAGE_CENTER",
        "DOCTORS_FEEDBACK",
        "DIET_CONSULTATION_DATA",
    ]

    filter_tabs(a: TabsClicked) {
        let unfiltered_list = [...this.list];
        unfiltered_list.forEach((ele) => {
            if (!a[ele]) {
                this.list.splice(this.list.indexOf(ele), 1);
            }
        });
        this.update_tabs_index(a, unfiltered_list);
    }

    update_tabs_index(a: TabsClicked, unfiltered_list: string[]) {
        unfiltered_list.forEach((ele) => {
            if (a[ele]) {
                this.index[ele] = this.list.indexOf(ele);
            }
            else {
                this.index[ele] = -1;
            }
        })
    }

}

@TraceClassDecorator()
@Component({
    selector: 'app-patientview',
    templateUrl: './patientview.component.html',
    styleUrls: ['./patientview.component.css',
        '../../../../../assets/css/custom-egd.css'],
    providers: [
        MessageService,
        ConfirmationService,
    ],
})
export class PatientviewComponent implements OnInit {

    @ViewChild(PatientBasicDetailsComponent) DEMOGRAPHIC_INFORMATION: PatientBasicDetailsComponent;
    @ViewChild(PastMedicalHistoryComponent) PATIENT_HISTORY: PastMedicalHistoryComponent;
    @ViewChild(MedicalReportsComponent) UPLOAD_MEDICAL_REPORTS: MedicalReportsComponent;
    @ViewChild(EglobaldoctorsConultationsComponent) EGLOBALDOCTORS_CONSULTATIONS: EglobaldoctorsConultationsComponent;
    @ViewChild(PatientvMessageCentreComponent) MESSAGE_CENTER: PatientvMessageCentreComponent;
    @ViewChild(DoctorFeedbackComponent) DOCTORS_FEEDBACK: DoctorFeedbackComponent;
    @ViewChild(DietConsultationDataComponent) DIET_CONSULTATION_DATA: DietConsultationDataComponent;

    tabs_clicked: TabsClicked = new TabsClicked(false);
    available_tabs: TabsClicked = new TabsClicked(true);
    tabs: Tabs = new Tabs();
    api_result: ApiResult = new ApiResult(true);
    api_result_zoom: ApiResult = new ApiResult(false);
    patientData: PatientAccount = null;
    current_tab_index: number = 0;
    consultation_data: ConsultationData = new ConsultationData();
    zoom_link: string = '';
    is_doctor_feedback: boolean = false;
    slug: string = "";
    constructor(
        private readonly patientView: PatientviewService,
        private readonly dateUtil: DateUtilService,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly appointmentService: AppointmentService,
        private readonly confirmation: ConfirmationService,
        private readonly messageService: MessageService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly providerstateService: ProviderStateService
    ) {

    }

    async getParams() {
        this.route.params.subscribe(async (params) => {
            this.consultation_data.patient_guid = params.patient_guid;
            this.consultation_data.consultation_id = Number(params.consultation_id);

            if (!(this.consultation_data.patient_guid) && !(this.consultation_data.consultation_id)) {
                this.consultation_data = new ConsultationData();
            }
        });
    }

    getTabIndex(s: string): number {
        return this.tabs.index[s];
    }

    async goToTab(s: number) {
        this.current_tab_index = s;
        await this.tabsCaseEvents(s);
    }

    async init() {
        if (!this.tabs_clicked.PARENT_PATIENT_VIEW) {
            await this.getParams();
            this.consultation_data.doctor_guid = sessionStorage.getItem('userid');
            await this.fetchData();
            if (this.isNutritionAndHealthConsultation()) {
                this.available_tabs.UPLOAD_MEDICAL_REPORTS = false;
                this.available_tabs.EGLOBALDOCTORS_CONSULTATIONS = false;
            }
            else {
                this.available_tabs.DIET_CONSULTATION_DATA = false;
            }
            if (this.isConsultationOpen()) {
                this.available_tabs.DOCTORS_FEEDBACK = false;
            }
            this.tabs.filter_tabs(this.available_tabs);
        }
    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: ['/', this.slug, 'doctor', 'dashboard'] },
            {
                label: 'Appointments', routerLink: ['/', this.slug, 'doctor', 'appointments']
            },
            { label: 'Patient View' }
        ]);
        await this.init();
    }

    async fetchData(): Promise<void> {
        this.api_result = new ApiResult(true);
        await this.patientView.fetchPersonalInfo(this.consultation_data.patient_guid, this.consultation_data.consultation_id)
            .toPromise()
            .then((result) => {
                this.api_result.PromiseResult = result;
                if (result.success) {
                    this.patientData = result.data;
                    this.patientData.avatar_url = Boolean(this.patientData.avatar_url) ? this.patientData.avatar_url : 'assets/images/avatar.png';
                    this.consultation_data.consultation_type_id = this.patientData.consultation[0].consultation_type_id

                    // this.goToTab(this.tabs.index.DEMOGRAPHIC_INFORMATION);
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.api_result.PromiseResult.success = false;
                this.api_result.Posting = false;
                this.api_result.ServerError = error.error;
            });
        this.tabs_clicked.PARENT_PATIENT_VIEW = true;
        this.api_result.Posting = false;
        this.changeDetector.detectChanges();
        if (this.api_result.PromiseResult.success && !this.isConsultationClosed()) {
            this.tabsCaseEvents(this.tabs.index.DEMOGRAPHIC_INFORMATION);
        }
    }

    async TestZoomCall() {
        this.api_result_zoom = new ApiResult(true);
        let data: AppointmentZoom = {
            patient_guid: this.consultation_data.patient_guid,
            consultation_id: this.consultation_data.consultation_id,
        }

        await this.appointmentService.ZoomAppointmentUrl(this.consultation_data.doctor_guid, data).toPromise().then(async result => {

            this.api_result_zoom.PromiseResult = result;
            if (this.api_result_zoom.PromiseResult.success) {
                this.zoom_link = result.data.start_url;

                if (this.zoom_link?.length > 0) {
                    window.open(this.zoom_link, '_blank');
                }
            }
            else if (!this.api_result_zoom.PromiseResult.success) {
                this.api_result_zoom.ErrorModel = result.error;
            }
        }).catch((error: HttpErrorResponse) => {
            this.api_result_zoom.ServerError = error.error;
            this.api_result_zoom.PromiseResult.success = false;
            this.api_result_zoom.Posting = false;
        });
        this.api_result_zoom.Posting = false;
    }

    async StartConsultation(event: Event) {
        await this.confirmAppointmentIntate(event);
    }

    async confirmAppointmentIntate(event: Event) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmation.confirm({
            key: 'confirm-dialog',
            header: 'Confirm Initiate Consultation',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            message: 'Are you sure you want to start the consultation ? Patient will be notified about this.',
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                await this.initate();
            },
        });
    }

    async backToAppoinments() {
        this.RouterNavigation('/appointments');
    }

    RouterNavigation(path: string) {
        this.router.navigate(['/' + this.slug + '/doctor/' + path]);
    }

    async AppointmentClose(event: Event) {
        event.preventDefault();
        this.confirmation.confirm({
            key: 'confirm-dialog',
            header: 'Feedback Stored ',
            acceptLabel: 'Okay',
            acceptIcon: 'pi pi-check',
            rejectVisible: false,
            message: 'Feedback Stored Successfully.',
            // icon: 'pi pi-check',
            accept: async () => {
                await this.backToAppoinments();
            },
        });
    }

    async SuccessCloseAppointment(event: Event) {
        await this.AppointmentClose(event)
    }

    isConsultationClosed(): boolean {
        if (!(this.patientData?.consultation[0]?.consultation_status)) {
            return false;
        }
        return this.patientData.consultation[0].consultation_status == 'CLOSED';
    }

    isConsultationOpen(): boolean {
        if (!(this.patientData?.consultation[0]?.consultation_status)) {
            return true;
        }
        return this.patientData.consultation[0].consultation_status == 'OPEN';
    }

    isdoctorsFeedback(): boolean {
        if (!(this.patientData?.consultation[0]?.consultation_status == 'SCHEDULED')) {
            return true;
        }
    }

    async initate() {
        this.api_result_zoom = new ApiResult(true);
        let data: AppointmentZoom = {
            patient_guid: this.consultation_data.patient_guid,
            consultation_id: this.consultation_data.consultation_id,
        }
        await this.appointmentService.InitiateAppointment(this.consultation_data.doctor_guid, data).toPromise().then(async result => {

            this.api_result_zoom.PromiseResult = result;
            if (this.api_result_zoom.PromiseResult.success) {
                this.is_doctor_feedback = true;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'The consultation has been successfully initiated',
                });
                this.patientData.consultation[0].consultation_status = result.data.consultation_status
                this.zoom_link = result.data.start_url;

                if (this.zoom_link?.length > 0) {
                    window.open(this.zoom_link, '_blank');
                }
                if (this.tabs_clicked[this.tabs.list[this.tabs.index.DOCTORS_FEEDBACK]]) {
                    this.tabs_clicked[this.tabs.list[this.tabs.index.DOCTORS_FEEDBACK]] = false;
                    await this.goToTab(this.tabs.index.DOCTORS_FEEDBACK);
                }


            }
            else if (!this.api_result_zoom.PromiseResult.success) {
                this.api_result_zoom.ErrorModel = result.error;
            }
        }).catch((error: HttpErrorResponse) => {
            this.api_result_zoom.ServerError = error.error;
            this.api_result_zoom.PromiseResult.success = false;
            this.api_result_zoom.Posting = false;
        });
        this.api_result_zoom.Posting = false;

    }

    findAge(): number {
        return this.dateUtil.diff(this.patientData.date_of_birth, new Date(), moment_duration.years);
    }

    async tabsCaseEvents(tab_number: number) {
        switch (tab_number) {
            case this.tabs.index.DEMOGRAPHIC_INFORMATION:
                if (!this.tabs_clicked[this.tabs.list[this.tabs.index.DEMOGRAPHIC_INFORMATION]]) {
                    this.DEMOGRAPHIC_INFORMATION.init();
                    this.tabs_clicked[this.tabs.list[this.tabs.index.DEMOGRAPHIC_INFORMATION]] = true;
                }
                break;
            case this.tabs.index.PATIENT_HISTORY:
                if (!this.tabs_clicked[this.tabs.list[this.tabs.index.PATIENT_HISTORY]]) {
                    await this.PATIENT_HISTORY.init();
                    this.tabs_clicked[this.tabs.list[this.tabs.index.PATIENT_HISTORY]] = true;
                }
                break;
            case this.tabs.index.UPLOAD_MEDICAL_REPORTS:
                if (!this.tabs_clicked[this.tabs.list[this.tabs.index.UPLOAD_MEDICAL_REPORTS]]) {
                    await this.UPLOAD_MEDICAL_REPORTS.init();
                    this.tabs_clicked[this.tabs.list[this.tabs.index.UPLOAD_MEDICAL_REPORTS]] = true;
                }
                break;
            case this.tabs.index.EGLOBALDOCTORS_CONSULTATIONS:
                if (!this.tabs_clicked[this.tabs.list[this.tabs.index.EGLOBALDOCTORS_CONSULTATIONS]]) {
                    await this.EGLOBALDOCTORS_CONSULTATIONS.init();
                    this.tabs_clicked[this.tabs.list[this.tabs.index.EGLOBALDOCTORS_CONSULTATIONS]] = true;
                }
                break;
            case this.tabs.index.MESSAGE_CENTER:
                if (!this.tabs_clicked[this.tabs.list[this.tabs.index.MESSAGE_CENTER]]) {
                    await this.MESSAGE_CENTER.init();
                    this.tabs_clicked[this.tabs.list[this.tabs.index.MESSAGE_CENTER]] = true;
                }
                break;
            case this.tabs.index.DOCTORS_FEEDBACK:
                if (!this.tabs_clicked[this.tabs.list[this.tabs.index.DOCTORS_FEEDBACK]]) {
                    await this.DOCTORS_FEEDBACK.init();
                    this.tabs_clicked[this.tabs.list[this.tabs.index.DOCTORS_FEEDBACK]] = true;
                }
                break;
            case this.tabs.index.DIET_CONSULTATION_DATA:
                if (!this.tabs_clicked[this.tabs.list[this.tabs.index.DIET_CONSULTATION_DATA]]) {
                    await this.DIET_CONSULTATION_DATA.init();
                    this.tabs_clicked[this.tabs.list[this.tabs.index.DIET_CONSULTATION_DATA]] = true;
                }
                break;
            default:
                break;
        }
    }

    async onTabChange(event: Event & { index: number }) {
        await this.tabsCaseEvents(event.index);
    }

    isNutritionAndHealthConsultation() {
        return this.consultation_data.consultation_type_id === CONSULTATION_TYPES.NUTRITION_AND_HEALTH_CONSULTATION;
    }


}
